import styled, { css } from 'styled-components';

import { FormBuilderModalWrapperStyled } from './FormBuilderModal.types';

export const FormBuilderModalWrapper = styled.div<FormBuilderModalWrapperStyled>`
  .modal-background {
    display: flex;
    padding-inline: 20px;

    .modal-container {
      margin: auto;

      ${({ dynamicHeight }) =>
        dynamicHeight
          ? css`
              height: auto;
            `
          : ''}

      ${({ maxWidth }) =>
        maxWidth
          ? css`
              max-width: ${maxWidth}px;
            `
          : ''}

      ${({ borderRadius }) =>
        borderRadius
          ? css`
              border-radius: ${borderRadius}px;
            `
          : ''}

      .modal-container-content {
        ${({ fullWidthContent }) =>
          fullWidthContent
            ? css`
                width: 100%;
              `
            : ''}
      }
    }
  }
`;
